import { CouponScopeEnum, CouponTypeEnum, CouponValueTypeEnum } from './enum';

export const CouponValueTypeLabels = {
  [CouponValueTypeEnum.PERCENT]: 'Desconto em %',
  [CouponValueTypeEnum.FIXED]: 'Desconto em R$',
};

export const CouponTypeLabels = {
  [CouponTypeEnum.DISCOUNT]: 'Desconto',
  [CouponTypeEnum.ENROLLMENT]: 'Adesão',
};

export const CouponScopeLabels = {
  [CouponScopeEnum.ALL]: 'Geral',
  [CouponScopeEnum.PLAN]: 'Plano',
  [CouponScopeEnum.ITEM_TOTAL]: 'Total em produtos',
  [CouponScopeEnum.ITEM]: 'Produto',
};

// Cor (JdsTag) por tipo de desconto: geral=verde, plano=azul, produto=amarelo.
export const CouponScopeColors = {
  [CouponScopeEnum.ALL]: 'success',
  [CouponScopeEnum.PLAN]: 'info',
  [CouponScopeEnum.ITEM_TOTAL]: 'warning',
  [CouponScopeEnum.ITEM]: 'warning',
};
